import React from 'react';
import { FDBox, FDStack } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  OnboardingAssetsAndLiabilitiesAddContent,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingAssetsAndLiabilitiesAdd/OnboardingAssetsAndLiabilitiesAddContent/OnboardingAssetsAndLiabilitiesAddContent';
import AssetsAndLiabilitiesHeader
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/AssetsAndLiabilitiesPartnerQuestion/AssetsAndLiabilitiesHeader';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import { GroupTotalValueCard } from 'Components/ComponentLibrary/Molecules/GroupTotalValueCard';
import useMobileLayout from 'Hooks/useMobileLayout';
import {
  isAssetsAndLiabilitiesContinueButtonDisabled,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingAssetsAndLiabilitiesAdd/Layout';

const OnboardingAssetsAndLiabilitiesSummaryLayout = () => {
  const {
    resource,
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();
  const isMobile = useMobileLayout();

  const isContinueButtonDisabled = isAssetsAndLiabilitiesContinueButtonDisabled(resource.attr('institutionGroups').resources().list());
  return (
    <FDBox>
      <FDStack direction={'column'} spacing={4}>
        <AssetsAndLiabilitiesHeader resource={resource} />
        <FDStack direction={isMobile ? 'column' : 'row'} spacing={isMobile ? 1 : 4} width={'100%'} paddingY={2}>
          {
            resource.attr('summaryGroups').resources().list().map((group) => {
              return (
                <GroupTotalValueCard
                  key={group.id()}
                  label={group.attr('title')}
                  value={group.attr('total')}
                  icon={group.attr('icon')}
                />
              );
            })
          }
        </FDStack>
        <OnboardingAssetsAndLiabilitiesAddContent resource={resource} />
      </FDStack>
      <SurveyStepFooter
        onSubmit={onSubmitMetaForm}
        NextButtonProps={{
          disabled: isContinueButtonDisabled,
        }}
      />
    </FDBox>
  );
};

OnboardingAssetsAndLiabilitiesSummaryLayout.defaultProps = {};

OnboardingAssetsAndLiabilitiesSummaryLayout.propTypes = {};

export { OnboardingAssetsAndLiabilitiesSummaryLayout };
